require("packs/filters");
require("packs/bookmarks");
require("packs/home_firebase");
require("packs/home_widget");
import "stylesheets/home.css";
import { setEvents } from "packs/bookmarks";
import { fetchAPI } from "packs/api";
import { staggerCards } from "packs/card_stagger";

// Disable browser's automatic scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

document.addEventListener("DOMContentLoaded", () => {
  // Scroll to top if custom pagination is visible (page > 1)
  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = urlParams.get('page');
  if (currentPage && parseInt(currentPage, 10) > 1) {
    window.scrollTo(0, 0);
  }

  // Sticky tab bar setup
  const tabBar = document.getElementById('deals-tab-bar');
  const tabPlaceholder = document.getElementById('deals-tab-placeholder');
  const tabBarInner = tabBar?.querySelector('.common-box');
  
  if (tabBar && tabPlaceholder && tabBarInner) {
    const tabBarTop = tabBar.offsetTop;
    let isSticky = false;
    
    const updateStickyState = () => {
      const shouldStick = window.scrollY >= tabBarTop;
      if (shouldStick !== isSticky) {
        isSticky = shouldStick;
        tabBar.classList.toggle('fixed', isSticky);
        tabBar.classList.toggle('top-0', isSticky);
        tabBar.classList.toggle('left-0', isSticky);
        tabBar.classList.toggle('px-0', isSticky);
        tabBar.classList.toggle('px-2', !isSticky);
        tabBar.classList.toggle('w-screen', isSticky);
        tabBarInner.classList.toggle('!rounded-t-none', isSticky);
        tabPlaceholder.classList.toggle('hidden', !isSticky);
      }
    };
    
    window.addEventListener('scroll', updateStickyState, { passive: true });
    updateStickyState();
  }

  // IntersectionObserver setup
  function observePageNumberDivs() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let pageNumber = entry.target.getAttribute("data-page-number");
          updateURLWithPageNumber(pageNumber);
        }
      });
    });

    document.querySelectorAll(".page-number-set").forEach((div) => {
      observer.observe(div);
    });
  }

  function updateURLWithPageNumber(pageNumber) {
    let params = new URLSearchParams(window.location.search);

    if (
      pageNumber === "1" ||
      pageNumber === undefined ||
      pageNumber.length === 0
    ) {
      params.delete("page");
    } else {
      params.set("page", pageNumber);
    }

    let newUrl = `${window.location.origin}${window.location.pathname}${
      params.toString() ? "?" + params.toString() : ""
    }`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  function appendHiddenDiv(pageNumber) {
    let dealsList = document.querySelector(".deals-list");

    if (dealsList) {
      let newDiv = document.createElement("div");
      newDiv.classList.add("page-number-set");
      newDiv.setAttribute("data-page-number", pageNumber);
      dealsList.appendChild(newDiv);

      observePageNumberDivs();
    }
  }

  observePageNumberDivs();

  var loading = false;
  var page = getPageFromURL();
  var lastRequestTime = 0;
  const THROTTLE_DELAY = 500; // 1 second delay between requests
  let showMoreButton = document.getElementById("show_more_deals");
  appendHiddenDiv(page);

  let requestedPages = new Set();
  
  function loadMoreContent() {
    const now = Date.now();
    if (!loading && 
        isElementInViewport(document.getElementById("append_pagination")) && 
        !requestedPages.has(page) &&
        now - lastRequestTime > THROTTLE_DELAY) {
      loading = true;
      lastRequestTime = now;
      document.getElementById("pagination-animation").classList.remove("hidden");
      showMoreButton.classList.add("hidden");
      
      var params = new URLSearchParams(window.location.search);
      params.set("page", page);
      var url = window.location.href.split("?")[0] + "?" + params.toString();
      
      fetchAPI(url, "GET", null, "script").then(response => {
        loading = false;
        document.getElementById("pagination-animation").classList.add("hidden");
        requestedPages.add(page);
        page += 1;
        appendHiddenDiv(page);
        setEvents();
        card_click();
        couponCodeCopy();
        staggerCards('.deals-list');
        // Re-initialize link tracking and coupon click for dynamically loaded content
        if (typeof initLinkTracking === 'function') initLinkTracking();
        if (typeof couponClick === 'function') couponClick();
        setTimeout(recalculateHeight, 100);
      }).catch(error => {
        loading = false;
        document.getElementById("pagination-animation").classList.add("hidden");
      });
    }
  }

  // Load more content on the click of show more button 

  if (showMoreButton) {
    showMoreButton.addEventListener("click", function(event) {
      window.scrollBy({
        top: -150, 
        behavior: 'smooth' 
      });
    });
  }

  let scrollThrottleTimer;
  window.addEventListener("scroll", () => {
    if (scrollThrottleTimer) clearTimeout(scrollThrottleTimer);
    scrollThrottleTimer = setTimeout(loadMoreContent, 100);
  });
  
  // Check if more content needs to be loaded after the initial page load
  setTimeout(loadMoreContent, THROTTLE_DELAY);

  function changeCardView(view) {
    let currentUrl = new URL(window.location.href);
    let displayViewParam = "display_view";
    let displayViewValue = view;
    currentUrl.searchParams.set(displayViewParam, displayViewValue);
    window.location.href = currentUrl;
  }
  document.querySelectorAll(".change-display-view").forEach((display) => {
    display.addEventListener("click", function () {
      changeCardView(this.dataset.view);
    });
  });

  document.querySelectorAll(".change-section").forEach((display) => {
    display.addEventListener("click", function (e) {
      e.preventDefault();
      changeSection(this.dataset.path);
    });
  });

  function changeSection(path) {
    let currentSearchParams = new URLSearchParams(window.location.search);
    let currentUrl = new URL(path, window.location.origin);
    
    currentSearchParams.forEach((value, key) => {
      // Skip the page parameter when switching tabs
      if (key === 'page') return;
      
      if (currentSearchParams.getAll(key).length > 1) {
        currentUrl.searchParams.delete(key);
        currentSearchParams.getAll(key).forEach(val => {
          currentUrl.searchParams.append(key, val);
        });
      } else {
        currentUrl.searchParams.set(key, value);
      }
    });
  
    window.location.href = currentUrl.toString();
  }
});

function isElementInViewport(el) {
  if (!el || el.style.display === "none") {
    return false;
  }

  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function recalculateHeight() {
  document.documentElement.scrollHeight;
}

function getPageFromURL() {
  let urlParams = new URLSearchParams(window.location.search);
  let pageParam = urlParams.get('page');
  return pageParam ? (parseInt(pageParam, 10) + 1) : 2;
}

